namespace $.$$ {

	export class $hyoo_intern_manager_card extends $.$hyoo_intern_manager_card {

	}

}
